export const $blue = '#00abbd';
export const $gray0 = '#121212';
export const $gray1 = '#c3c3c3';
export const $gray2 = '#818181';
export const $gray3 = '#F6F6F6';
export const $gray4 = '#E2E2E2';
export const $orange = '#FFCA00';
export const $box_blue = '#41539D';
/********** Colors **********/
export const $black = '#242424';
export const $warm_grey = '#818181'
export const $pinkish_grey = '#c3c3c3'
export const $light_grey = '#e2e2e2'
export const $white = '#FBFBFB';
export const $marigold = '#ffca00';
export const $denim_blue= '#41539d';
export const $turquoise_blue = '#00abbd';
export const $default_hover_bg = '#6479bc';
export const $second_hover_bg = '#f1f1f1';
export const $second_hover_color = '#00abbd';




export const Flex = {

    flex_wrap: "display: flex; flex-wrap: wrap;"
    ,
    flex_nowrap: "display: flex; flex-wrap: nowrap;"
    ,
    flex_center : "align-items: center; justify-content: center; align-content: center;"
    ,
    flex_start : "align-items: center; align-content: center; justify-content: flex-start;"
    ,
    flex_full_start : "align-items: flex-start; justify-content: flex-start; align-content: flex-start;"
    ,
    flex_end : "align-items: center; justify-content: flex-end; align-content: center;"
    ,
    flex_full_end : "align-items: flex-end; justify-content:flex-end; align-content: flex-end;"
    ,
    flex_space_between:"justifyContent:space-between; "
}
export const Breakpoints={
    Tablet:'600px',
    Laptop:'1198px',
    Wide:'1680px',
}

export const contentPadding={
    mobile:'7%',
    Tablet:'7%',
    Laptop:'8%',
    Wide:'13%',
}
export const headerPadding={
    mobile:'7.5%',
    Tablet:'5%',
    Laptop:'7.5%',
    Wide:'12.5%',
}
export const footerPadding={
    mobile:'105%',
    Tablet:'70%',
    Laptop:'40%',
    Wide:'47%',
}
export const homeheader={
    mobile:'85%',
    Tablet:'86%',
    Laptop:'83.5%',
    Wide:'74%',
}

